// https://stackoverflow.com/a/11818658/1933131
export function toFixed(num, fixed) {
  return num
    .toString()
    .match(new RegExp('^-?\\d+(?:.\\d{0,' + (fixed || -1) + '})?'))[0];
}
